import QRCode from "qrcode";

export const generatePartnerQRCode = async (
  referralCode: string,
  baseUrl?: string,
): Promise<string> => {
  try {
    const referralUrl = `${
      baseUrl || window.location.origin
    }/bid-request?ref=${encodeURIComponent(referralCode)}`;

    const qrCodeDataUrl = await QRCode.toDataURL(referralUrl, {
      width: 300,
      margin: 2,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
      errorCorrectionLevel: "M",
    });

    return qrCodeDataUrl;
  } catch (error) {
    console.error("Error generating QR code:", error);
    throw new Error("Failed to generate QR code");
  }
};

export const downloadQRCode = (dataUrl: string, referralCode: string) => {
  try {
    const link = document.createElement("a");
    link.download = `partner-qr-${referralCode}.png`;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading QR code:", error);
    throw new Error("Failed to download QR code");
  }
};
